export const SIGNATURE_IMAGE_TYPE = "image/png";

export const getSignatureDataUrl = (signatureCanvas) => {
  if (!signatureCanvas || typeof signatureCanvas.toDataURL !== "function") {
    throw new Error("Signature canvas is unavailable.");
  }

  return signatureCanvas.toDataURL(SIGNATURE_IMAGE_TYPE);
};
